define([
    "jquery",
    "underscore",
    "marionette",
    "views/withdrawal/common_view",
    "forms/withdrawal/help2pay_idmy_form"
], function($, _, Marionette, CommonView, Help2PayIdMyForm) {
    return CommonView.extend({

        ui: _.extend(CommonView.prototype.ui, {
            'currencySelect':'#currency_abbr',
            'bankSelect':'#bank_code',
            'amount' : '#amount'
        }),

        events: _.extend(CommonView.prototype.events, {
            'change @ui.currencySelect': function() {
                var currencyValue = $('#currency_abbr').val();

                $('#bank_code').empty();
                window.bankCodes[currencyValue].forEach( function(data) {
                    $('#bank_code').append('<option value="' + data.bank_code + '">' + data.bank_name + '</option>');
                });
            },

            'keyup @ui.amount': 'updateUsdAmount',
        }),

        initialize: function(){
            this.bindUIElements();
            this.form = new Help2PayIdMyForm();

            this.setScheduler();
        },

        setScheduler: function ()
        {
            window.setInterval(this.requestWithdrawableAmount, 2000);
        },

        updateUsdAmount: function() {
            let currencyValue = $('#currency_abbr').val();
            const fx_rate = currencyValue.trim() == 'IDR' ? window.fx_rates.IDR : window.fx_rates.MYR;
            $('#usd_amount').text( "$ "+ ($('#amount').val()*fx_rate).toFixed(2));
        },

        requestWithdrawableAmount: function() {
            const mt4AccountNo = $('#mt4_account_no').find(":selected").val();
            const currency = window.currentCurrency;

            $.ajax({
                url: `/rest_withdrawal/withdrawable_amount?mt4_account_no=${mt4AccountNo}&currency=${currency}`,
                method: "GET",
                success: function(data) {
                    $('#withdrawable_amount').text(data.freeMargin);
                }
            })
        }
    });
});
